<div [formGroup]="form">
    <div>
        @switch (field.controlType) {
            @case ('buttonAttachFile') {
                <div>
                    <label [attr.for]="field.key" class="formLabel" style="display: table-cell;">{{field.label}}</label>
                    <div style="display: table-cell">
                        <input [formControlName]="field.key" [id]="field.key" [type]="field.type" (change)="attachFileChange($event)" class="formField" style="display: inline-block; vertical-align: middle; width: auto;" accept=".pdf,.doc,.docx" [placeholder]="field.placeholder">
                        @if (isUploadingFile) {
                            <img src="{{localImageLocation}}ajax-loader.gif" class="fileUploadIndicator" alt="loading">
                        }
                        <input [formControlName]="'AttachedFile'" [id]="'AttachedFile'" type="hidden">
                        <input [formControlName]="'AttachedFileType'" [id]="'AttachedFileType'" type="hidden">
                        <input [formControlName]="'AttachedFileOriginalName'" [id]="'AttachedFileOriginalName'" type="hidden">
                        <span [innerHTML]="field.description" class="formFieldTextDescription"></span>
                        @if (field.required) {
                            <span class="formFieldRequired">*</span>
                        }
                        <div style="clear: both;"></div>
                        <cp-field-error-display [displayError]="isInvalid()" errorMessage="{{field.validationText}}"></cp-field-error-display>
                    </div>
                </div>
            }
            @case ('buttonClear') {
                <div>
                    <input [formControlName]="field.key" [type]="field.type" [value]="field.label" class="formButton">
                </div>
            }
            @case ('buttonSubmit') {
                <div>
                    <input [formControlName]="field.key" [type]="field.type" class="formButton">
                </div>
            }
            @case ('buttonCheckIdentity') {
                <div>
                    <input [formControlName]="field.key" [type]="field.type" class="formButton">
                </div>
            }
            @case ('buttonVerifyIdentity') {
                <div>
                    <input [formControlName]="field.key" [type]="field.type" class="formButton">
                </div>
            }
            @case ('buttonSubmitAndClear') {
                <div>
                    <div class="formLabel">&nbsp;</div>
                    <input type="submit" [disabled]="!form.valid" [value]="field.label" class="formButton">
                    <input type="reset" [value]="field.extra" (click)="onClearForm()" class="formButton">
                </div>
            }
            @case ('captcha') {
                <div>
                    <span hidden="true" name="captchaToken"></span>
                </div>
            }
            @case ('choice') {
                <div>
                    <label [attr.for]="field.key" class="formLabel">{{field.label}}</label>
                    <select [formControlName]="field.key" [id]="field.key" class="formField">
                        @for (option of field.options; track option) {
                            <option [value]="option.key">{{option.value}}</option>
                        }
                    </select>
                    @if (field.required) {
                        <span class="formFieldRequired">*</span>
                    }
                    <div style="clear: both;"></div>
                    <cp-field-error-display [displayError]="isInvalid()" errorMessage="{{field.validationText}}"></cp-field-error-display>
                </div>
            }
            @case ('date') {
                <div>
                    <label [attr.for]="field.key" class="formLabel">{{field.label}}</label>
                    <my-date-picker class="formField" style="border-color: #ababab;" [formControlName]="field.key"></my-date-picker>
                    @if (field.required) {
                        <span class="formFieldRequired">*</span>
                    }
                    <div style="clear: both;"></div>
                    <cp-field-error-display [displayError]="isInvalid()" errorMessage="{{field.validationText}}"></cp-field-error-display>
                </div>
            }
            @case ('description') {
                <div>
                    <span class="formMainDescription" [innerHTML]="field.label"></span>
                </div>
            }
            @case ('email') {
                <div>
                    @if (field.placeholder === '') {
                        <label [attr.for]="field.key" class="formLabel">{{field.label}}</label>
                    }
                    <input [formControlName]="field.key" [id]="field.key" [type]="field.type" class="formField" style="width: 200px;" [value]="field.value" [placeholder]="field.placeholder">
                    @if (field.required) {
                        <span class="formFieldRequired">*</span>
                    }
                    <div style="clear: both;"></div>
                    <cp-field-error-display  [displayError]="isInvalid()" errorMessage="{{field.validationText}}"></cp-field-error-display>
                </div>
            }
            @case ('heading') {
                <div class="formHeading">
                    <span [innerHTML]="field.label" class="formGroupHeading"></span>
                </div>
            }
            @case ('multiLineText') {
                <div>
                    @if (field.placeholder === '') {
                        <label [attr.for]="field.key" class="formLabel">{{field.label}}</label>
                    }
                    <textarea [formControlName]="field.key" [id]="field.key" [style.width.px]="field.width" [style.height.px]="field.height" class="formField" [placeholder]="field.placeholder">{{field.value}}</textarea>
                    @if (field.required) {
                        <span class="formFieldRequired">*</span>
                    }
                    <div style="clear: both;"></div>
                    <cp-field-error-display [displayError]="isInvalid()" errorMessage="{{field.validationText}}"></cp-field-error-display>
                </div>
            }
            @case ('number') {
                <div>
                    @if (field.placeholder === '') {
                        <label [attr.for]="field.key" class="formLabel">{{field.label}}</label>
                    }
                    <input [formControlName]="field.key" [id]="field.key" [type]="field.type" NumberOnly="true" class="formField" [value]="field.value" [placeholder]="field.placeholder">
                    @if (field.required) {
                        <span class="formFieldRequired">*</span>
                    }
                    <div style="clear: both;"></div>
                    <cp-field-error-display [displayError]="isInvalid()" errorMessage="{{field.validationText}}"></cp-field-error-display>
                </div>
            }
            @case ('password') {
                <div>
                    @if (field.placeholder === '') {
                        <label [attr.for]="field.key" class="formLabel">{{field.label}}</label>
                    }
                    <input [formControlName]="field.key" [id]="field.key" [type]="'password'" class="formField" style="width: 200px;" [placeholder]="field.placeholder">
                    @if (field.required) {
                        <span class="formFieldRequired">*</span>
                    }
                    <div style="clear: both;"></div>
                    <cp-field-error-display [displayError]="isInvalid()" errorMessage="{{field.validationText}}"></cp-field-error-display>
                </div>
            }
            @case ('singleLineText') {
                <div>
                    @if (field.description !== '' && field.description !== undefined) {
                        <div class="tooltip">
                            @if (field.placeholder === '') {
                                <label [attr.for]="field.key" class="formLabel">{{field.label}}</label>
                            }
                            <input [formControlName]="field.key" [id]="field.key" [type]="field.type" class="formField" [value]="field.value" [placeholder]="field.placeholder">
                            <span class="tooltiptext">{{field.description}}</span>
                            @if (field.required) {
                                <span class="formFieldRequired">*</span>
                            }
                        </div>
                    }
                    @if (field.description === '' || field.description === undefined) {
                        <div>
                            @if (field.placeholder === '') {
                                <label [attr.for]="field.key" class="formLabel">{{field.label}}</label>
                            }
                            <input [formControlName]="field.key" [id]="field.key" [type]="field.type" class="formField" [value]="field.value" [placeholder]="field.placeholder">
                            <span class="tooltiptext">{{field.description}}</span>
                            @if (field.required) {
                                <span class="formFieldRequired">*</span>
                            }
                        </div>
                    }
                    <div style="clear: both;"></div>
                    <cp-field-error-display [displayError]="isInvalid()" errorMessage="{{field.validationText}}"></cp-field-error-display>
                </div>
            }
            @case ('special') {
                <div>
                    @if (field.key.toLowerCase() === 'currency') {
                        <label [attr.for]="field.key" class="formLabel">{{field.label}}</label>
                        <select [formControlName]="field.key" [id]="field.key" class="formField" [(ngModel)]="defaultExpenseCurrency">
                        @for (choice of dynamicChoices; track choice) {
                            <option [value]="choice.Id">{{choice.Id}}</option>
                        }
                        </select>
                    }
                    @if (field.key.toLowerCase() === 'category') {
                        <label [attr.for]="field.key" class="formLabel">{{field.label}}</label>
                        <select [formControlName]="field.key" [id]="field.key" class="formField">
                            @for (choice of dynamicChoices; track choice) {
                                <option [value]="choice.Id">{{choice.Name}}</option>
                            }
                        </select>
                    }
                    @if (field.required) {
                        <span class="formFieldRequired">*</span>
                    }
                    <div style="clear: both;"></div>
                    <cp-field-error-display [displayError]="isInvalid()" errorMessage="{{field.validationText}}"></cp-field-error-display>
                </div>
            }
            @case ('yesno') {
                <div>
                    <label [attr.for]="field.key" class="formLabel">{{field.label}}</label>
                    <input [formControlName]="field.key" [id]="field.key" [type]="'checkbox'" class="formField" style="width: 200px;">
                    @if (field.required) {
                        <span class="formFieldRequired">*</span>
                    }
                    <div style="clear: both;"></div>
                    <cp-field-error-display [displayError]="isInvalid()" errorMessage="{{field.validationText}}"></cp-field-error-display>
                </div>
            }
            @case ('msgFailure') {
                <div></div>
            }
            @case ('msgEmailSubject') {
                <div>
                    <input [formControlName]="field.key" [id]="field.key" [value]="field.value" type="hidden">
                </div>
            }
            @case ('msgEmailConfirm') {
                <div>
                    <input [formControlName]="field.key" [id]="field.key" [value]="field.value" type="hidden">
                </div>
            }
        }
    </div>
</div>
